import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e67563f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-more-popover" }

import { computed, PropType, ref } from "vue";
import {
  TirPmModal,
  TirPmPopover,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  PopoverPositionEnum,
} from "tir-components";
import { PopoverOptionList, PopoverOptionLi } from "../popover-option-list";
import {
  PencilSquareIcon,
  AdjustmentsVerticalIcon,
  TrashIcon,
} from "tir-style-system/icons/outline";
import { NamespaceModel, GroupModel, QueueTasksModel } from "../../models";
import { TreeItemType } from "../../enums";
import { AdapterService } from "../../adapter";
import SidebarEditPopoverFolderForm from "../sidebar-edit-popover-folder-form.vue";
import SidebarEditPopoverQueueForm from "../sidebar-edit-popover-queue-form.vue";
import SidebarRenamePopoverNamespaceForm from "../sidebar-rename-popover-namespace-form.vue";
import { QueueCardtemModel } from "@/components/queue-card";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'sidebar-more-popover',
  props: {
  /**Элемент меню */
  menuItem: {
    type: Object as PropType<NamespaceModel | GroupModel | QueueTasksModel | QueueCardtemModel>,
    required: true,
  },
  position: {
    type: String as PropType<PopoverPositionEnum>,
    default: PopoverPositionEnum.Auto,
  },
},
  emits: ["onDeleteNamespace", "onDeleteGroup", "onDeleteQueue", "onUpdateGroup", "onUpdateQueue", "onUpdateNamespace", "toggleVisible", "editQueue"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const router = useRouter();

const adapter = new AdapterService();




let owner = false;

/**Элемент рабочей области */
const namespaceItem = computed(() => (props.menuItem.isNamespace() ? props.menuItem : undefined));
/**Элемент группы */
const groupItem = computed(() => (props.menuItem.isGroup() ? props.menuItem : undefined));
/**Элемент очереди задач */
const queueItem = computed(() => (props.menuItem.isQueue() ? props.menuItem : undefined));

/**Ссылка на компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

/**Отобразить форму переименования */
const viewRenameForm = ref(false);

/**Ширина поповера */
const width = computed(() => {
  if (viewRenameForm.value) return "25rem";
  return "17.5rem";
});

/**
 * * При открытии поповера
 */
const onOpenPopover = () => {
  emit("toggleVisible", true);
};

/**
 * * При закрытии поповера
 */
const onClosePopover = () => {
  viewRenameForm.value = false;
  if (!deleteConfirmModalVisible.value) emit("toggleVisible", false);
};

/**Видимость модального окна с подтверждением удаления */
const deleteConfirmModalVisible = ref(false);
/**Сообщение для модального окна подтверждения удаления */
const deleteConfirmModalMessage = ref("");

/**Открыть форму переименования */
const openRenameForm = () => {
  viewRenameForm.value = true;
  $popover.value?.init(true);
};

/**Открыть модальное окно подтверждения удаления */
const openDeleteConfirmModal = () => {
  switch (true) {
    case props.menuItem.isNamespace():
      deleteConfirmModalMessage.value = `Вы дейтсвительно хотите удалить раздел "${props.menuItem.Name}"?`;
      break;
    case props.menuItem.isGroup():
      deleteConfirmModalMessage.value = `Вы дейтсвительно хотите удалить папку "${props.menuItem.Name}"?`;
      break;
    case props.menuItem.isQueue():
      deleteConfirmModalMessage.value = `Вы дейтсвительно хотите удалить "${props.menuItem.Name}"?`;
    default:
      break;
  }
  deleteConfirmModalVisible.value = true;
  $popover.value?.close();
};

/**Закрыть модальное окно подтверждения удаления */
const closeDeleteConfirmModal = () => {
  deleteConfirmModalVisible.value = false;
  deleteConfirmModalMessage.value = "";
  emit("toggleVisible", false);
};

/**Отмена удаления в модальном окне подтверждения */
const cancelDeleteConfrimModal = async () => {
  closeDeleteConfirmModal();
  setTimeout(() => {
    $popover.value?.open();
  });
};

/**Удалить пункт меню */
const deleteMenuItem = async () => {
  const menuItem = props.menuItem;

  if (menuItem.isNamespace()) {
    const resp = await adapter.deleteNamespace(menuItem.Id, menuItem.Name);
    if (resp.IsSuccess) {
      closeDeleteConfirmModal();
      emit("onDeleteNamespace", menuItem.Id);
    }
  } else if (menuItem.isGroup()) {
    const resp = await adapter.deleteGroup(menuItem.Id, menuItem.Name);
    if (resp.IsSuccess) {
      closeDeleteConfirmModal();
      emit("onDeleteGroup", menuItem.Id);
    }
  } else if (menuItem.isQueue()) {
    const resp = await adapter.deleteQueue(menuItem.Id, menuItem.Name);
    if (resp.IsSuccess) {
      closeDeleteConfirmModal();
      emit("onDeleteQueue", menuItem.Id);
    }
  }

  closeDeleteConfirmModal();
};

/**
 * * При обновлении группы
 * @param group Группа
 */
const onUpdateGroup = (group: GroupModel) => {
  emit("onUpdateGroup", group);
  $popover.value?.close();
};

/**
 * * При обновлении очереди
 * @param queue Очередь
 */
const onUpdateQueue = (queue: QueueTasksModel) => {
  emit("onUpdateQueue", queue);
  $popover.value?.close();
};

/**
 * * При обновлении неймспейса
 * @param namespace Неймспейс
 */
const onUpdateNamespace = (namespace: NamespaceModel) => {
  emit("onUpdateNamespace", namespace);
  $popover.value?.close();
};

const edit = () => {
  $popover.value?.close();
  if (props.menuItem.isQueue()) {
    emit("editQueue");
  } else if (props.menuItem.isNamespace()) {
    router.push({
      name: "namespace-settings",
      params: {
        namespaceId: props.menuItem.Id,
      },
    });
  }
};
__expose({
  edit,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmPopover), {
      ref_key: "$popover",
      ref: $popover,
      width: width.value,
      position: __props.position,
      onClose: onClosePopover,
      onClick: onOpenPopover
    }, {
      content: _withCtx(() => [
        (viewRenameForm.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (groupItem.value)
                ? (_openBlock(), _createBlock(SidebarEditPopoverFolderForm, {
                    key: 0,
                    group: groupItem.value,
                    onOnUpdate: onUpdateGroup
                  }, null, 8, ["group"]))
                : (queueItem.value)
                  ? (_openBlock(), _createBlock(SidebarEditPopoverQueueForm, {
                      key: 1,
                      queue: queueItem.value,
                      onOnUpdate: onUpdateQueue
                    }, null, 8, ["queue"]))
                  : (namespaceItem.value)
                    ? (_openBlock(), _createBlock(SidebarRenamePopoverNamespaceForm, {
                        key: 2,
                        namespace: namespaceItem.value,
                        onOnUpdate: onUpdateNamespace
                      }, null, 8, ["namespace"]))
                    : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_unref(PopoverOptionList), { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_unref(PopoverOptionLi), {
                  onClick: _withModifiers(openRenameForm, ["stop"])
                }, {
                  "left-icon": _withCtx(() => [
                    _createVNode(_unref(PencilSquareIcon))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Переименовать ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                ([_unref(TreeItemType).Queue, _unref(TreeItemType).Namespace].includes(__props.menuItem.Type))
                  ? (_openBlock(), _createBlock(_unref(PopoverOptionLi), {
                      key: 0,
                      onClick: edit
                    }, {
                      "left-icon": _withCtx(() => [
                        _createVNode(_unref(AdjustmentsVerticalIcon))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Настройки ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(PopoverOptionLi), {
                  onClick: _withModifiers(openDeleteConfirmModal, ["stop"])
                }, {
                  "left-icon": _withCtx(() => [
                    _createVNode(_unref(TrashIcon))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Удалить ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "target")
      ]),
      _: 3
    }, 8, ["width", "position"]),
    _createVNode(_unref(TirPmModal), {
      "is-visible": deleteConfirmModalVisible.value,
      "is-with-back": false,
      title: deleteConfirmModalMessage.value,
      onClose: cancelDeleteConfrimModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(TirPmButton), {
          style: {"width":"6.5rem"},
          size: _unref(TirPmButtonSizeEnum).Regular,
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          onClick: cancelDeleteConfrimModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Нет ")
          ]),
          _: 1
        }, 8, ["size", "variant"]),
        _createVNode(_unref(TirPmButton), {
          style: {"width":"6.5rem"},
          size: _unref(TirPmButtonSizeEnum).Regular,
          variant: _unref(TirPmButtonVariantEnum).SecondaryState,
          onClick: deleteMenuItem
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Да ")
          ]),
          _: 1
        }, 8, ["size", "variant"])
      ]),
      _: 1
    }, 8, ["is-visible", "title"])
  ]))
}
}

})